import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  size: "x-small",
  style: {"font-style":"italic"}
}
const _hoisted_2 = {
  key: 0,
  style: {"font-style":"italic","font-size":"x-small"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_BookletContent = _resolveComponent("BookletContent", true)!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pa-0",
    style: {"overflow":"hidden"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card_wm mb-0 pb-0 elevation-0",
        style: _normalizeStyle(_ctx.bookletContentCardStyle)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              (!_ctx.previewMode)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    class: "d-flex pr-1",
                    cols: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.search,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                                label: "Rechercher",
                                "single-line": "",
                                "hide-details": "",
                                class: "pb-1 px-1",
                                "append-inner-icon": "$search",
                                density: "compact",
                                clearable: "",
                                "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tabs, {
                                modelValue: _ctx.accountingFormCategory,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountingFormCategory) = $event)),
                                direction: "vertical"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingFormCategories, (category) => {
                                    return (_openBlock(), _createBlock(_component_v_tab, {
                                      key: category.category,
                                      text: category.name,
                                      value: category.category
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, _toDisplayString(category.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["text", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "my-1 pl-2",
                            style: {"height":"calc(100vh - 300px)","overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_draggable, {
                                class: "list-group",
                                list: _ctx.accountingFormsPages,
                                group: { name: 'a', pull: 'clone', put: false },
                                options: { disabled: _ctx.readonly },
                                itemKey: "id",
                                draggable: ".item"
                              }, {
                                item: _withCtx(({ element: page, index: pi }) => [
                                  (
                                            page.category === _ctx.accountingFormCategory &&
                                            _ctx.searchedPages.includes(page)
                                        )
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        class: _normalizeClass(_ctx.getAccountingFormClass(page.disabled)),
                                        key: page.cerfa,
                                        disabled: _ctx.readonly || page.disabled,
                                        border: true,
                                        rounded: "",
                                        onClick: ($event: any) => (_ctx.addIntoBooklet(page, pi))
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                                default: _withCtx(() => [
                                                  (
                                                            page.format &&
                                                            !page.bothFormatUsed &&
                                                            _ctx.isInBooklet(page)
                                                        )
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        rounded: "",
                                                        size: "x-small",
                                                        elevation: "0",
                                                        style: _normalizeStyle(
                                                            _ctx.readonly
                                                                ? ''
                                                                : 'pointer-events: initial !important;'
                                                        ),
                                                        disabled: _ctx.readonly,
                                                        onClick: _withModifiers(($event: any) => (
                                                            _ctx.readonly
                                                                ? null
                                                                : _ctx.addDifferentFormat(page, pi)
                                                        ), ["stop"])
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("+ " + _toDisplayString(_ctx.newFormat(page)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["style", "disabled", "onClick"]))
                                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 1,
                                                        dense: "",
                                                        size: "x-small"
                                                      }, {
                                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                          _createTextVNode("$add")
                                                        ])),
                                                        _: 1
                                                      }))
                                                ]),
                                                _: 2
                                              }, 1024),
                                              (
                                                        _ctx.accountingFormCategory ===
                                                        'personalisedDocument'
                                                    )
                                                ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_menu, { location: "start" }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                                            dense: "",
                                                            size: "small",
                                                            style: 
                                                                    _ctx.readonly
                                                                        ? ''
                                                                        : 'pointer-events: initial !important;'
                                                                ,
                                                            disabled: _ctx.readonly
                                                          }), null, 16, ["style", "disabled"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list, { density: "compact" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_list_item, {
                                                                onClick: _withModifiers(($event: any) => (
                                                                    _ctx.persoDocToUpdate = page.cerfa
                                                                ), ["stop"])
                                                              }, {
                                                                append: _withCtx(() => [
                                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                                      _createTextVNode("$oss-edit")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                                      _createTextVNode("Changer le titre")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]),
                                                              _createVNode(_component_v_list_item, {
                                                                onClick: _withModifiers(($event: any) => (
                                                                    _ctx.persoDocToDelete = page.cerfa
                                                                ), ["stop"])
                                                              }, {
                                                                append: _withCtx(() => [
                                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                                      _createTextVNode("$oss-trash")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                                      _createTextVNode("Supprimer")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"])
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.displayTitle(page)), 1),
                                          (page.printableTitle)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "  " + _toDisplayString(page.printableTitle), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "disabled", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["list", "options"]),
                              (_ctx.accountingFormCategory === 'personalisedDocument')
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    class: _normalizeClass(_ctx.getAccountingFormClassForUploadFile()),
                                    disabled: _ctx.readonly,
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openUploadFileDialog()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_icon, { icon: "$fa-upload" })
                                    ]),
                                    _: 1
                                  }, 8, ["class", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, {
                class: "px-1 pb-1",
                cols: _ctx.previewMode ? '12' : '6'
              }, {
                default: _withCtx(() => [
                  (_ctx.booklet)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "mb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: _ctx.previewMode ? 10 : 12,
                                    class: "title d-flex align-center justify-center"
                                  }, {
                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                      _createElementVNode("h4", null, "Détail", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["cols"]),
                                  (_ctx.previewMode)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "2",
                                        class: "justify-end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            fab: "",
                                            size: "small",
                                            elevation: "0",
                                            onClick: _ctx.openCustomDialog,
                                            icon: "$oss-edit"
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "my-3 d-flex align-start",
                            style: _normalizeStyle(_ctx.heightOfBookletView)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_draggable, {
                                class: "list-group py-6",
                                id: _ctx.booklet.id,
                                list: _ctx.booklet.pages,
                                group: { name: 'a' },
                                draggable: ".item",
                                itemKey: "id2",
                                handle: ".handle",
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateBooklet($event))),
                                options: { disabled: _ctx.readonly || _ctx.previewMode }
                              }, {
                                item: _withCtx(({ element: page, index: pi }) => [
                                  (_openBlock(), _createBlock(_component_v_list_item, {
                                    class: "list-group-item oss-list-item item mt-1",
                                    key: page.cerfa + '_' + page.format + '_' + pi,
                                    style: {"cursor":"default"},
                                    border: true,
                                    rounded: ""
                                  }, {
                                    prepend: _withCtx(() => [
                                      (!_ctx.previewMode)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            icon: "$fa-align-justify",
                                            size: "x-small",
                                            disabled: !_ctx.isDraggable(page),
                                            class: _normalizeClass(_ctx.isDraggable(page))
                                          }, null, 8, ["disabled", "class"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    append: _withCtx(() => [
                                      (page.format)
                                        ? (_openBlock(), _createBlock(_component_v_menu, {
                                            key: 0,
                                            absolute: "",
                                            "offset-y": ""
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              (!_ctx.previewMode)
                                                ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                                                    dense: "",
                                                    disabled: _ctx.readonly,
                                                    size: "x-small"
                                                  }), {
                                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                      _createTextVNode("$oss-edit")
                                                    ])),
                                                    _: 2
                                                  }, 1040, ["disabled"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, { lines: "one" }, {
                                                    default: _withCtx(() => [
                                                      _cache[20] || (_cache[20] = _createTextVNode(" Format saisie ")),
                                                      _createVNode(_component_v_switch, {
                                                        modelValue: page.format,
                                                        "onUpdate:modelValue": ($event: any) => ((page.format) = $event),
                                                        "false-value": "saisie",
                                                        "true-value": "cerfa",
                                                        onChange: ($event: any) => (_ctx.changeFormat(page)),
                                                        size: "small"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                                      _cache[21] || (_cache[21] = _createTextVNode(" Format CERFA "))
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      (!_ctx.previewMode)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            class: "ml-2",
                                            disabled: _ctx.readonly,
                                            onClick: _withModifiers(($event: any) => (_ctx.removeFromBooklet(page, pi)), ["stop"]),
                                            size: "x-small"
                                          }, {
                                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                              _createTextVNode("$oss-trash")
                                            ])),
                                            _: 2
                                          }, 1032, ["disabled", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.displayTitle(page)), 1),
                                        (page.format)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "  " + _toDisplayString(_ctx.displayPageFormat(page.format)), 1))
                                          : _createCommentVNode("", true),
                                        (page.printableTitle !== undefined)
                                          ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                              key: 1,
                                              modelValue: page.printableTitle,
                                              "onUpdate:modelValue": ($event: any) => ((page.printableTitle) = $event),
                                              "hide-details": "",
                                              class: "pl-2 separationPageTextField",
                                              disabled: _ctx.readonly || _ctx.previewMode,
                                              style: _normalizeStyle(
                                                    _ctx.readonly || _ctx.previewMode
                                                        ? 'pointer-events: none !important;'
                                                        : ''
                                                ),
                                              density: "compact"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "style"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                ]),
                                _: 1
                              }, 8, ["id", "list", "options"])
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          (_ctx.booklet.pages && _ctx.booklet.pages.length > 7)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "d-flex justify-center",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.booklet.pages.length) + " pages ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.customBookletTemplateDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customBookletTemplateDialog) = $event)),
        title: "Modifiez votre plaquette personnalisée"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_BookletContent, {
              booklet: _ctx.duplicatedBooklet,
              initialBooklet: _ctx.booklet,
              bundleId: _ctx.bookletTemplateId,
              bundleType: _ctx.bundleType,
              onBookletChanged: _ctx.onDuplicatedBookletChanged
            }, null, 8, ["booklet", "initialBooklet", "bundleId", "bundleType", "onBookletChanged"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.personalisedDocumentsDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.personalisedDocumentsDialog,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.personalisedDocumentsDialog) = $event)),
            title: "Importer un document personnalisé",
            "previous-display": false,
            actions: _ctx.actions,
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocuments, {
                companyId: _ctx.accountingCompanyId,
                documentType: 'BOOKLET_TEMPLATE',
                multiple: false,
                freeTag: false,
                inExtensions: ['docx', 'pdf'],
                actions: _ctx.actions,
                onFile: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addPersonalisedDoc($event)))
              }, null, 8, ["companyId", "actions"])
            ]),
            _: 1
          }, 8, ["modelValue", "actions"]))
        : _createCommentVNode("", true),
      (_ctx.persoDocToUpdate)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            modelValue: _ctx.persoDocToUpdate,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.persoDocToUpdate) = $event)),
            title: "Modifier le titre",
            "previous-display": false,
            validLoading: _ctx.newNameLoading,
            validDisabled: !_ctx.newName,
            onValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updatePersonalisedDocName(_ctx.persoDocToUpdate, _ctx.newName))),
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.newName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newName) = $event)),
                label: "Nouveau nom",
                outlined: "",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "validLoading", "validDisabled"]))
        : _createCommentVNode("", true),
      (_ctx.persoDocToDelete)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            modelValue: _ctx.persoDocToDelete,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.persoDocToDelete) = $event)),
            title: "Supprimer ce document",
            "previous-display": false,
            validLoading: _ctx.deleteLoading,
            onValid: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deletePersonalisedDoc())),
            width: "800px"
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer ce document ?", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "validLoading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}